module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/wrong-questions'
      }
    }
  }, [_vm._v("错题集")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 错题详情")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.userdata.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("会员号：")]), _vm._v(_vm._s(_vm.userdata.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_center"
  }, [_c('div', {
    staticClass: "question_title"
  }, [(_vm.questionData.options && _vm.questionData.options.length == 2) ? _c('el-tag', [_vm._v("\n            单选")]) : _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(" 多选")]), _vm._v("\n          " + _vm._s(_vm.questionData.questiontitle ? _vm.questionData.questiontitle.title : "") + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "question_optoins"
  }, _vm._l((_vm.questionData.options), function(option, index) {
    return _c('div', {
      key: index
    }, [_c('el-button', {
      staticStyle: {
        "min-width": "253px !important"
      },
      attrs: {
        "type": option.selected == 1 ? 'primary' : '',
        "round": "",
        "plain": option.selected == 1 ? false : true
      }
    }, [_vm._v(_vm._s(option.title))])], 1)
  }), 0), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "width": "500px",
      "margin": "50px auto 20px auto"
    },
    attrs: {
      "title": "回答错误",
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n          答案："), _c('span', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v(_vm._s(_vm.answers))]), _vm._v(" "), _c('br'), _vm._v("\n          解析：" + _vm._s(_vm.questionData.questiontitle ? _vm.questionData.questiontitle.jiexi : "") + "\n        ")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b7c5c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/WrongQuestionDetail.vue
// module id = 1156
// module chunks = 0